import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { db } from '../../firebaseConfig';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { Box, Button, Typography, Container } from '@mui/material';

const TrackProduct = () => {
    const { userId, prodId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const userData = JSON.parse(localStorage.getItem("user") || null);
    const [stage, setStage] = useState('To-initiate');
    const [requestUpdate, setRequestUpdate] = useState(false);
    const [product, setProduct] = useState({});

    useEffect(() => {
        if (!location.state) {
            const orderId = `${prodId}${userId}`;
            const orderRef = doc(db, 'order', orderId);
            getDoc(orderRef).then((doc) => {
                if (doc.exists()) {
                    const data = doc.data();
                    setProduct(data);
                    setStage(data.stage);
                    if (data.buyerRequestedUpdate) {
                        setRequestUpdate(true);
                    }
                }
            });
        } else {
            setProduct(location.state.product);
            setStage(location.state.product.stage);
        }
    }, [userId, prodId, location]);

    const handleStageUpdate = async (newStage) => {
        if (userData.phone === prodId) {
            const orderId = `${prodId}${userId}`;
            const orderRef = doc(db, 'order', orderId);
            await setDoc(orderRef, { stage: newStage }, { merge: true });
            setStage(newStage);
        }
    };

    const handleRequestUpdate = async () => {
        if (userData.phone !== prodId) {
            setRequestUpdate(true);
            const orderId = `${prodId}${userId}`;
            const orderRef = doc(db, 'order', orderId);
            await setDoc(orderRef, { buyerRequestedUpdate: true }, { merge: true });
            const updatedDoc = await getDoc(orderRef);
            if (updatedDoc.exists()) {
                const data = updatedDoc.data();
                setStage(data.stage);
            }
        }
    };

    return (
        <Container sx={{ mt: 3 }}>
            <Typography variant="h4" align="center" fontWeight={600} gutterBottom>
                TimeLine
            </Typography>
            <Box sx={{ textAlign: 'center', mb: 3 }}>
                {product.img && (
                    <img 
                        src={product.img} 
                        alt={product.badge} 
                        style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }} 
                    />
                )}
                <Typography variant="h6">Current Stage: {stage}</Typography>
                {requestUpdate && (
                    <Typography color="error">
                        Buyer has requested an update.
                    </Typography>
                )}
            </Box>
            {userData.phone === prodId ? (
                <>
                    <Button variant="contained" color="primary" onClick={() => handleStageUpdate('In process')}>
                        Update to In process
                    </Button>
                    <Button variant="contained" color="primary" onClick={() => handleStageUpdate('Ready to deliver')}>
                        Update to Ready to deliver
                    </Button>
                </>
            ) : (
                <Button variant="contained" color="secondary" onClick={handleRequestUpdate}>
                    Request Update
                </Button>
            )}
            {stage === 'Ready to deliver' && (
                <Button 
                    variant="contained" 
                    color="success" 
                    onClick={() => navigate(`/store/${userId}/${prodId}/payment`, { state: { product } })}>
                    Proceed to Payment
                </Button>
            )}
        </Container>
    );
};

export default TrackProduct;
